// src/utils/translations.js - 完整版
const translationsData = {
  // 中文
  zh: {
    // 通用
    title: '收银系统',
    
    // 登录页面
    pleaseLogin: '请登录以继续',
    username: '用户名',
    password: '密码',
    login: '登录',
    loggingIn: '登录中...',
    loginFailed: '登录失败',
    pleaseEnterCredentials: '请输入用户名和密码',
    testAccounts: '测试账号',
    admin: '管理员',
    cashier: '收银员',
    
    // 导航
    pos: '收银台',
    shift: '班次管理',
    dashboard: '数据看板',
    products: '商品管理',
    categories: '分类管理',
    employees: '员工管理',
    
    // 商品管理
    addProduct: '添加商品',
    editProduct: '编辑商品',
    deleteProduct: '删除商品',
    productName: '商品名称',
    barcode: '条码',
    category: '分类',
    price: '价格',
    stock: '库存',
    costPrice: '成本价',
    salePrice: '售价',
    minStock: '最低库存',
    addSuccess: '添加成功',
    addFailed: '添加失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    editFeatureInDevelopment: '编辑功能开发中',
    loadProductsFailed: '加载商品失败',
    operationFailed: '操作失败',
    retry: '重试',
    
    // 收银台
    cart: '购物车',
    total: '总计',
    checkout: '结算',
    paymentMethod: '支付方式',
    cash: '现金',
    card: '刷卡',
    mobile: '移动支付',
    searchPlaceholder: '搜索商品名称或条码...',
    currentShift: '当前班次',
    startingCash: '起始现金',
    noActiveShift: '请先在"班次管理"页面开始班次',
    cartIsEmpty: '购物车是空的！',
    pleaseStartShift: '请先开始班次！',
    orderSuccess: '订单创建成功！',
    orderFailed: '订单创建失败',
    
    // 操作
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    logout: '退出',
    increase: '增加',
    decrease: '减少',
    
    // 上传
    uploadFailed: '上传失败',
    uploading: '上传中...',
    uploadSuccess: '上传成功',

    // 门店管理
    storesTitle: '门店管理',
    storesSubtitle: '管理总店与所有分店信息',
    addBranchBtn: '新增分店',
    totalStoresLabel: '门店总数',
    branchCountLabel: '分店数量',
    activeStatus: '营业中',
    closedStatus: '已关闭',
    headquartersLabel: '总店',
    branchListLabel: '分店列表',
    noBranchesText: '暂无分店',
    editStoreTitle: '编辑门店',
    storeNameZhLabel: '门店名称（中文）',
    storeNamePlaceholder: '例：北区分店',
    storeNameLangLabel: '门店名称（{lang}）',
    langEnglish: '英文',
    langKhmer: '高棉语',
    langMalay: '马来语',
    langTraditionalChinese: '繁体中文',
    englishNamePlaceholder: '例：North Branch',
    addressLabel: '地址',
    addressPlaceholder: '门店地址',
    phoneLabel: '联系电话',
    phonePlaceholder: '联系电话',
    commissionRateLabel: '管理费比例（%）',
    commissionRateHint: '每笔订单总店收取的佣金百分比',
    commissionRateExample: '例：输入 5 表示总店收取订单金额的 5%，分店得剩余 95% + 配送费',
    statusLabel: '状态',
    savingBtn: '保存中...',
    managementFeeLabel: '管理费：{percent}%',
    errNameRequired: '门店名称不能为空',
    errRateRange: '佣金比例需在 0-100 之间',
    errOperationFailed: '操作失败',
    loadingStoresText: '加载中...',

    // 导航菜单（之前陆续新增的功能，一直没接入翻译）
    inventoryManagementNav: '库存管理',
    inventoryLogsNav: '库存变动记录',
    salesReportNav: '销售报表',
    stockTransfersNav: '库存划拨',
    onlineOrdersNav: '线上订单',
    customerManagementNav: '客户管理',
    shopSettingsNav: '商家设置',
    usdtWithdrawNav: 'USDT提币审核',
    plusCodeLabel: '门店位置（Plus Code）',
    plusCodeHint: '在Google地图上找到门店位置，复制Plus Code粘贴到这里',
    plusCodePlaceholder: '例：7P36HW4H+H7',
    errInvalidPlusCode: 'Plus Code格式不正确，请检查后重新输入',
    sectionNamesLabel: '门店名称',
    sectionContactLabel: '联系方式与位置',
    sectionOperationsLabel: '运营设置',
    optionalLabel: '选填',
    supportsPickupLabel: '支持到店自提',
    supportsPickupHint: '（关闭后，该门店不会出现在客户端自提门店候选列表中）',
    pickupSupportedBadge: '支持自提',
    pickupUnsupportedBadge: '不支持自提'
  },

  // English
  en: {
    // General
    title: 'POS System',
    
    // Login Page
    pleaseLogin: 'Please login to continue',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
    loginFailed: 'Login failed',
    pleaseEnterCredentials: 'Please enter username and password',
    testAccounts: 'Test Accounts',
    admin: 'Admin',
    cashier: 'Cashier',
    
    // Navigation
    pos: 'POS',
    shift: 'Shift Management',
    dashboard: 'Dashboard',
    products: 'Products',
    categories: 'Categories',
    employees: 'Employees',
    
    // Product Management
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    deleteProduct: 'Delete Product',
    productName: 'Product Name',
    barcode: 'Barcode',
    category: 'Category',
    price: 'Price',
    stock: 'Stock',
    costPrice: 'Cost Price',
    salePrice: 'Sale Price',
    minStock: 'Min Stock',
    addSuccess: 'Added successfully',
    addFailed: 'Failed to add',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete',
    editFeatureInDevelopment: 'Edit feature in development',
    loadProductsFailed: 'Failed to load products',
    operationFailed: 'Operation failed',
    retry: 'Retry',
    
    // POS
    cart: 'Shopping Cart',
    total: 'Total',
    checkout: 'Checkout',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    card: 'Card',
    mobile: 'Mobile Payment',
    searchPlaceholder: 'Search product name or barcode...',
    currentShift: 'Current Shift',
    startingCash: 'Starting Cash',
    noActiveShift: 'Please start a shift in "Shift Management" first',
    cartIsEmpty: 'Cart is empty!',
    pleaseStartShift: 'Please start a shift first!',
    orderSuccess: 'Order created successfully!',
    orderFailed: 'Failed to create order',
    
    // Actions
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    logout: 'Logout',
    increase: 'Increase',
    decrease: 'Decrease',
    
    // Upload
    uploadFailed: 'Upload failed',
    uploading: 'Uploading...',
    uploadSuccess: 'Upload successful',

    // Store Management
    storesTitle: 'Store Management',
    storesSubtitle: 'Manage headquarters and all branch information',
    addBranchBtn: 'Add Branch',
    totalStoresLabel: 'Total Stores',
    branchCountLabel: 'Branch Count',
    activeStatus: 'Open',
    closedStatus: 'Closed',
    headquartersLabel: 'Headquarters',
    branchListLabel: 'Branch List',
    noBranchesText: 'No branches yet',
    editStoreTitle: 'Edit Store',
    storeNameZhLabel: 'Store Name (Chinese)',
    storeNamePlaceholder: 'e.g. North District Branch',
    storeNameLangLabel: 'Store Name ({lang})',
    langEnglish: 'English',
    langKhmer: 'Khmer',
    langMalay: 'Malay',
    langTraditionalChinese: 'Traditional Chinese',
    englishNamePlaceholder: 'e.g. North Branch',
    addressLabel: 'Address',
    addressPlaceholder: 'Store address',
    phoneLabel: 'Phone',
    phonePlaceholder: 'Contact phone',
    commissionRateLabel: 'Commission Rate (%)',
    commissionRateHint: 'Percentage of each order collected by HQ as commission',
    commissionRateExample: 'e.g. entering 5 means HQ takes 5% of the order amount, the branch keeps the remaining 95% + delivery fee',
    statusLabel: 'Status',
    savingBtn: 'Saving...',
    managementFeeLabel: 'Fee: {percent}%',
    errNameRequired: 'Store name cannot be empty',
    errRateRange: 'Commission rate must be between 0-100',
    errOperationFailed: 'Operation failed',
    loadingStoresText: 'Loading...',

    // Navigation Menu
    inventoryManagementNav: 'Inventory',
    inventoryLogsNav: 'Inventory Logs',
    salesReportNav: 'Sales Report',
    stockTransfersNav: 'Stock Transfers',
    onlineOrdersNav: 'Online Orders',
    customerManagementNav: 'Customers',
    shopSettingsNav: 'Shop Settings',
    usdtWithdrawNav: 'USDT Withdrawal Review',
    plusCodeLabel: 'Store Location (Plus Code)',
    plusCodeHint: 'Find the store on Google Maps, copy the Plus Code and paste it here',
    plusCodePlaceholder: 'e.g. 7P36HW4H+H7',
    errInvalidPlusCode: 'Invalid Plus Code format, please check and re-enter',
    sectionNamesLabel: 'Store Names',
    sectionContactLabel: 'Contact & Location',
    sectionOperationsLabel: 'Operations',
    optionalLabel: 'Optional',
    supportsPickupLabel: 'Supports In-Store Pickup',
    supportsPickupHint: '(When disabled, this store will not appear in the customer pickup list)',
    pickupSupportedBadge: 'Pickup Supported',
    pickupUnsupportedBadge: 'Pickup Not Supported'
  },

  // ខ្មែរ (Khmer)
  km: {
    // ទូទៅ
    title: 'ប្រព័ន្ធលក់រាយ',
    
    // ទំព័រចូល
    pleaseLogin: 'សូមចូលដើម្បីបន្ត',
    username: 'ឈ្មោះអ្នកប្រើ',
    password: 'ពាក្យសម្ងាត់',
    login: 'ចូល',
    loggingIn: 'កំពុងចូល...',
    loginFailed: 'ការចូលបានបរាជ័យ',
    pleaseEnterCredentials: 'សូមបញ្ចូលឈ្មោះអ្នកប្រើនិងពាក្យសម្ងាត់',
    testAccounts: 'គណនីសាកល្បង',
    admin: 'អ្នកគ្រប់គ្រង',
    cashier: 'អ្នកគិតលុយ',
    
    // ការរុករក
    pos: 'ម៉ាស៊ីនគិតលុយ',
    shift: 'គ្រប់គ្រងវេន',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    products: 'ទំនិញ',
    categories: 'ប្រភេទ',
    employees: 'បុគ្គលិក',
    
    // គ្រប់គ្រងទំនិញ
    addProduct: 'បន្ថែមទំនិញ',
    editProduct: 'កែសម្រួលទំនិញ',
    deleteProduct: 'លុបទំនិញ',
    productName: 'ឈ្មោះទំនិញ',
    barcode: 'បាកូដ',
    category: 'ប្រភេទ',
    price: 'តម្លៃ',
    stock: 'ស្តុក',
    costPrice: 'តម្លៃដើម',
    salePrice: 'តម្លៃលក់',
    minStock: 'ស្តុកអប្បបរមា',
    addSuccess: 'បានបន្ថែមដោយជោគជ័យ',
    addFailed: 'បរាជ័យក្នុងការបន្ថែម',
    deleteSuccess: 'បានលុបដោយជោគជ័យ',
    deleteFailed: 'បរាជ័យក្នុងការលុប',
    editFeatureInDevelopment: 'មុខងារកែសម្រួលកំពុងអភិវឌ្ឍ',
    loadProductsFailed: 'បរាជ័យក្នុងការផ្ទុកទំនិញ',
    operationFailed: 'ប្រតិបត្តិការបានបរាជ័យ',
    retry: 'ព្យាយាមម្តងទៀត',
    
    // ម៉ាស៊ីនគិតលុយ
    cart: 'រទេះទិញ',
    total: 'សរុប',
    checkout: 'គិតលុយ',
    paymentMethod: 'វិធីបង់ប្រាក់',
    cash: 'សាច់ប្រាក់',
    card: 'កាត',
    mobile: 'បង់តាមទូរស័ព្ទ',
    searchPlaceholder: 'ស្វែងរកឈ្មោះទំនិញ ឬបាកូដ...',
    currentShift: 'វេនបច្ចុប្បន្ន',
    startingCash: 'សាច់ប្រាក់ដំបូង',
    noActiveShift: 'សូមចាប់ផ្តើមវេននៅក្នុង "គ្រប់គ្រងវេន" ជាមុនសិន',
    cartIsEmpty: 'រទេះទិញទទេ!',
    pleaseStartShift: 'សូមចាប់ផ្តើមវេនជាមុនសិន!',
    orderSuccess: 'បង្កើតការបញ្ជាទិញបានជោគជ័យ!',
    orderFailed: 'បរាជ័យក្នុងការបង្កើតការបញ្ជាទិញ',
    
    // សកម្មភាព
    save: 'រក្សាទុក',
    cancel: 'បោះបង់',
    confirm: 'បញ្ជាក់',
    delete: 'លុប',
    edit: 'កែសម្រួល',
    search: 'ស្វែងរក',
    logout: 'ចេញ',
    increase: 'បន្ថែម',
    decrease: 'បន្ថយ',
    
    // ផ្ទុកឡើង
    uploadFailed: 'បរាជ័យក្នុងការផ្ទុកឡើង',
    uploading: 'កំពុងផ្ទុកឡើង...',
    uploadSuccess: 'ផ្ទុកឡើងបានជោគជ័យ',

    // គ្រប់គ្រងហាង
    storesTitle: 'គ្រប់គ្រងហាង',
    storesSubtitle: 'គ្រប់គ្រងព័ត៌មានការិយាល័យកណ្តាល និងសាខាទាំងអស់',
    addBranchBtn: 'បន្ថែមសាខា',
    totalStoresLabel: 'ចំនួនហាងសរុប',
    branchCountLabel: 'ចំនួនសាខា',
    activeStatus: 'កំពុងបើក',
    closedStatus: 'បិទ',
    headquartersLabel: 'ការិយាល័យកណ្តាល',
    branchListLabel: 'បញ្ជីសាខា',
    noBranchesText: 'មិនទាន់មានសាខាទេ',
    editStoreTitle: 'កែសម្រួលហាង',
    storeNameZhLabel: 'ឈ្មោះហាង（中文）',
    storeNamePlaceholder: 'ឧទាហរណ៍：北区分店',
    storeNameLangLabel: 'ឈ្មោះហាង（{lang}）',
    langEnglish: 'ភាសាអង់គ្លេស',
    langKhmer: 'ភាសាខ្មែរ',
    langMalay: 'ភាសាម៉ាឡេ',
    langTraditionalChinese: 'ចិនបុរាណ',
    englishNamePlaceholder: 'ឧទាហរណ៍：North Branch',
    addressLabel: 'អាសយដ្ឋាន',
    addressPlaceholder: 'អាសយដ្ឋានហាង',
    phoneLabel: 'លេខទូរស័ព្ទទំនាក់ទំនង',
    phonePlaceholder: 'លេខទូរស័ព្ទទំនាក់ទំនង',
    commissionRateLabel: 'អត្រាកម្រៃជើងសារ（%）',
    commissionRateHint: 'ភាគរយកម្រៃជើងសារដែលការិយាល័យកណ្តាលទទួលក្នុងមួយការបញ្ជាទិញ',
    commissionRateExample: 'ឧទាហរណ៍：បញ្ចូល 5 មានន័យថាការិយាល័យកណ្តាលទទួល 5% នៃចំនួនទឹកប្រាក់ការបញ្ជាទិញ សាខាទទួល 95% ដែលនៅសល់ + ថ្លៃដឹកជញ្ជូន',
    statusLabel: 'ស្ថានភាព',
    savingBtn: 'កំពុងរក្សាទុក...',
    managementFeeLabel: 'កម្រៃជើងសារ：{percent}%',
    errNameRequired: 'ឈ្មោះហាងមិនអាចទទេបានទេ',
    errRateRange: 'អត្រាកម្រៃជើងសារត្រូវនៅចន្លោះ 0-100',
    errOperationFailed: 'ប្រតិបត្តិការបានបរាជ័យ',
    loadingStoresText: 'កំពុងផ្ទុក...',

    // ម៉ឺនុយរុករក
    inventoryManagementNav: 'គ្រប់គ្រងស្តុក',
    inventoryLogsNav: 'កំណត់ត្រាការផ្លាស់ប្តូរស្តុក',
    salesReportNav: 'របាយការណ៍លក់',
    stockTransfersNav: 'ការផ្ទេរស្តុក',
    onlineOrdersNav: 'ការបញ្ជាទិញអនឡាញ',
    customerManagementNav: 'គ្រប់គ្រងអតិថិជន',
    shopSettingsNav: 'ការកំណត់ហាង',
    usdtWithdrawNav: 'ការត្រួតពិនិត្យដកប្រាក់ USDT',
    plusCodeLabel: 'ទីតាំងហាង（Plus Code）',
    plusCodeHint: 'ស្វែងរកទីតាំងហាងនៅលើ Google Maps ចម្លង Plus Code មកបិទភ្ជាប់នៅទីនេះ',
    plusCodePlaceholder: 'ឧទាហរណ៍：7P36HW4H+H7',
    errInvalidPlusCode: 'ទម្រង់ Plus Code មិនត្រឹមត្រូវ សូមពិនិត្យ ហើយបញ្ចូលម្តងទៀត',
    sectionNamesLabel: 'ឈ្មោះហាង',
    sectionContactLabel: 'ទំនាក់ទំនង និងទីតាំង',
    sectionOperationsLabel: 'ការកំណត់ប្រតិបត្តិការ',
    optionalLabel: 'ស្រេចចិត្ត',
    supportsPickupLabel: 'គាំទ្រការមករបស់ដោយខ្លួនឯងនៅហាង',
    supportsPickupHint: '（នៅពេលបិទ ហាងនេះនឹងមិនបង្ហាញក្នុងបញ្ជីហាងសម្រាប់មករបស់ដោយខ្លួនឯងទេ）',
    pickupSupportedBadge: 'គាំទ្រការមករបស់',
    pickupUnsupportedBadge: 'មិនគាំទ្រការមករបស់'
  },

  // Bahasa Melayu (Malay)
  ms: {
    // Umum
    title: 'Sistem Kasir',

    // Halaman Log Masuk
    pleaseLogin: 'Sila log masuk untuk teruskan',
    username: 'Nama Pengguna',
    password: 'Kata Laluan',
    login: 'Log Masuk',
    loggingIn: 'Sedang log masuk...',
    loginFailed: 'Log masuk gagal',
    pleaseEnterCredentials: 'Sila masukkan nama pengguna dan kata laluan',
    testAccounts: 'Akaun Ujian',
    admin: 'Pentadbir',
    cashier: 'Juruwang',

    // Navigasi
    pos: 'Kaunter Bayaran',
    shift: 'Pengurusan Syif',
    dashboard: 'Papan Pemuka',
    products: 'Pengurusan Produk',
    categories: 'Pengurusan Kategori',
    employees: 'Pengurusan Pekerja',

    // Pengurusan Produk
    addProduct: 'Tambah Produk',
    editProduct: 'Edit Produk',
    deleteProduct: 'Padam Produk',
    productName: 'Nama Produk',
    barcode: 'Kod Bar',
    category: 'Kategori',
    price: 'Harga',
    stock: 'Stok',
    costPrice: 'Harga Kos',
    salePrice: 'Harga Jualan',
    minStock: 'Stok Minimum',
    addSuccess: 'Berjaya ditambah',
    addFailed: 'Gagal menambah',
    deleteSuccess: 'Berjaya dipadam',
    deleteFailed: 'Gagal memadam',
    editFeatureInDevelopment: 'Ciri edit sedang dibangunkan',
    loadProductsFailed: 'Gagal memuatkan produk',
    operationFailed: 'Operasi gagal',
    retry: 'Cuba Semula',

    // Kaunter Bayaran
    cart: 'Troli',
    total: 'Jumlah',
    checkout: 'Bayar',
    paymentMethod: 'Kaedah Pembayaran',
    cash: 'Tunai',
    card: 'Kad',
    mobile: 'Pembayaran Mudah Alih',
    searchPlaceholder: 'Cari nama produk atau kod bar...',
    currentShift: 'Syif Semasa',
    startingCash: 'Tunai Permulaan',
    noActiveShift: 'Sila mulakan syif di halaman "Pengurusan Syif" dahulu',
    cartIsEmpty: 'Troli kosong!',
    pleaseStartShift: 'Sila mulakan syif dahulu!',
    orderSuccess: 'Pesanan berjaya dibuat!',
    orderFailed: 'Gagal membuat pesanan',

    // Tindakan
    save: 'Simpan',
    cancel: 'Batal',
    confirm: 'Sahkan',
    delete: 'Padam',
    edit: 'Edit',
    search: 'Cari',
    logout: 'Log Keluar',
    increase: 'Tambah',
    decrease: 'Kurang',

    // Muat Naik
    uploadFailed: 'Muat naik gagal',
    uploading: 'Sedang memuat naik...',
    uploadSuccess: 'Muat naik berjaya',

    // Pengurusan Kedai
    storesTitle: 'Pengurusan Kedai',
    storesSubtitle: 'Uruskan ibu pejabat dan maklumat semua cawangan',
    addBranchBtn: 'Tambah Cawangan',
    totalStoresLabel: 'Jumlah Kedai',
    branchCountLabel: 'Bilangan Cawangan',
    activeStatus: 'Buka',
    closedStatus: 'Tutup',
    headquartersLabel: 'Ibu Pejabat',
    branchListLabel: 'Senarai Cawangan',
    noBranchesText: 'Tiada cawangan lagi',
    editStoreTitle: 'Edit Kedai',
    storeNameZhLabel: 'Nama Kedai (Cina)',
    storeNamePlaceholder: 'cth: Cawangan Daerah Utara',
    storeNameLangLabel: 'Nama Kedai ({lang})',
    langEnglish: 'Bahasa Inggeris',
    langKhmer: 'Bahasa Khmer',
    langMalay: 'Bahasa Melayu',
    langTraditionalChinese: 'Cina Tradisional',
    englishNamePlaceholder: 'cth: North Branch',
    addressLabel: 'Alamat',
    addressPlaceholder: 'Alamat kedai',
    phoneLabel: 'Telefon',
    phonePlaceholder: 'Nombor telefon',
    commissionRateLabel: 'Kadar Komisen (%)',
    commissionRateHint: 'Peratusan komisen yang dikutip oleh ibu pejabat bagi setiap pesanan',
    commissionRateExample: 'cth: memasukkan 5 bermaksud ibu pejabat mengambil 5% daripada jumlah pesanan, cawangan menyimpan baki 95% + yuran penghantaran',
    statusLabel: 'Status',
    savingBtn: 'Sedang menyimpan...',
    managementFeeLabel: 'Yuran: {percent}%',
    errNameRequired: 'Nama kedai tidak boleh kosong',
    errRateRange: 'Kadar komisen mesti antara 0-100',
    errOperationFailed: 'Operasi gagal',
    loadingStoresText: 'Sedang memuatkan...',

    // Menu Navigasi
    inventoryManagementNav: 'Inventori',
    inventoryLogsNav: 'Log Perubahan Inventori',
    salesReportNav: 'Laporan Jualan',
    stockTransfersNav: 'Pemindahan Stok',
    onlineOrdersNav: 'Pesanan Dalam Talian',
    customerManagementNav: 'Pelanggan',
    shopSettingsNav: 'Tetapan Kedai',
    usdtWithdrawNav: 'Semakan Pengeluaran USDT',
    plusCodeLabel: 'Lokasi Kedai (Plus Code)',
    plusCodeHint: 'Cari kedai di Google Maps, salin Plus Code dan tampal di sini',
    plusCodePlaceholder: 'cth: 7P36HW4H+H7',
    errInvalidPlusCode: 'Format Plus Code tidak sah, sila semak dan masukkan semula',
    sectionNamesLabel: 'Nama Kedai',
    sectionContactLabel: 'Hubungan & Lokasi',
    sectionOperationsLabel: 'Operasi',
    optionalLabel: 'Pilihan',
    supportsPickupLabel: 'Menyokong Ambil di Kedai',
    supportsPickupHint: '(Apabila dimatikan, kedai ini tidak akan muncul dalam senarai kedai ambil pelanggan)',
    pickupSupportedBadge: 'Sokong Ambil Sendiri',
    pickupUnsupportedBadge: 'Tidak Sokong Ambil Sendiri'
  },

  // 繁體中文
  zh_tw: {
    // 通用
    title: '收銀系統',

    // 登入頁面
    pleaseLogin: '請登入以繼續',
    username: '使用者名稱',
    password: '密碼',
    login: '登入',
    loggingIn: '登入中...',
    loginFailed: '登入失敗',
    pleaseEnterCredentials: '請輸入使用者名稱和密碼',
    testAccounts: '測試帳號',
    admin: '管理員',
    cashier: '收銀員',

    // 導覽
    pos: '收銀台',
    shift: '班次管理',
    dashboard: '數據看板',
    products: '商品管理',
    categories: '分類管理',
    employees: '員工管理',

    // 商品管理
    addProduct: '新增商品',
    editProduct: '編輯商品',
    deleteProduct: '刪除商品',
    productName: '商品名稱',
    barcode: '條碼',
    category: '分類',
    price: '價格',
    stock: '庫存',
    costPrice: '成本價',
    salePrice: '售價',
    minStock: '最低庫存',
    addSuccess: '新增成功',
    addFailed: '新增失敗',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
    editFeatureInDevelopment: '編輯功能開發中',
    loadProductsFailed: '載入商品失敗',
    operationFailed: '操作失敗',
    retry: '重試',

    // 收銀台
    cart: '購物車',
    total: '總計',
    checkout: '結算',
    paymentMethod: '支付方式',
    cash: '現金',
    card: '刷卡',
    mobile: '行動支付',
    searchPlaceholder: '搜尋商品名稱或條碼...',
    currentShift: '目前班次',
    startingCash: '起始現金',
    noActiveShift: '請先在「班次管理」頁面開始班次',
    cartIsEmpty: '購物車是空的！',
    pleaseStartShift: '請先開始班次！',
    orderSuccess: '訂單建立成功！',
    orderFailed: '訂單建立失敗',

    // 操作
    save: '儲存',
    cancel: '取消',
    confirm: '確認',
    delete: '刪除',
    edit: '編輯',
    search: '搜尋',
    logout: '登出',
    increase: '增加',
    decrease: '減少',

    // 上傳
    uploadFailed: '上傳失敗',
    uploading: '上傳中...',
    uploadSuccess: '上傳成功',

    // 門店管理
    storesTitle: '門店管理',
    storesSubtitle: '管理總店與所有分店資訊',
    addBranchBtn: '新增分店',
    totalStoresLabel: '門店總數',
    branchCountLabel: '分店數量',
    activeStatus: '營業中',
    closedStatus: '已關閉',
    headquartersLabel: '總店',
    branchListLabel: '分店列表',
    noBranchesText: '暫無分店',
    editStoreTitle: '編輯門店',
    storeNameZhLabel: '門店名稱（中文）',
    storeNamePlaceholder: '例：北區分店',
    storeNameLangLabel: '門店名稱（{lang}）',
    langEnglish: '英文',
    langKhmer: '高棉語',
    langMalay: '馬來語',
    langTraditionalChinese: '繁體中文',
    englishNamePlaceholder: '例：North Branch',
    addressLabel: '地址',
    addressPlaceholder: '門店地址',
    phoneLabel: '聯絡電話',
    phonePlaceholder: '聯絡電話',
    commissionRateLabel: '管理費比例（%）',
    commissionRateHint: '每筆訂單總店收取的佣金百分比',
    commissionRateExample: '例：輸入 5 表示總店收取訂單金額的 5%，分店得剩餘 95% + 配送費',
    statusLabel: '狀態',
    savingBtn: '儲存中...',
    managementFeeLabel: '管理費：{percent}%',
    errNameRequired: '門店名稱不能為空',
    errRateRange: '佣金比例需在 0-100 之間',
    errOperationFailed: '操作失敗',
    loadingStoresText: '載入中...',

    // 導覽選單
    inventoryManagementNav: '庫存管理',
    inventoryLogsNav: '庫存變動記錄',
    salesReportNav: '銷售報表',
    stockTransfersNav: '庫存劃撥',
    onlineOrdersNav: '線上訂單',
    customerManagementNav: '客戶管理',
    shopSettingsNav: '商家設置',
    usdtWithdrawNav: 'USDT提幣審核',
    plusCodeLabel: '門店位置（Plus Code）',
    plusCodeHint: '在Google地圖上找到門店位置，複製Plus Code貼到這裡',
    plusCodePlaceholder: '例：7P36HW4H+H7',
    errInvalidPlusCode: 'Plus Code格式不正確，請檢查後重新輸入',
    sectionNamesLabel: '門店名稱',
    sectionContactLabel: '聯絡方式與位置',
    sectionOperationsLabel: '營運設置',
    optionalLabel: '選填',
    supportsPickupLabel: '支援到店自取',
    supportsPickupHint: '（關閉後，該門店不會出現在客戶端自取門店候選清單中）',
    pickupSupportedBadge: '支援自取',
    pickupUnsupportedBadge: '不支援自取'
  }
};

// 用 Proxy 包一层：任何还没有翻译内容的语言代码（以后再加新语言，翻译还没跟上的
// 空窗期），访问 translations[未知代码] 会自动退回中文，不会返回 undefined 导致
// 整个应用崩溃——所有页面组件不用做任何改动，因为大家用的还是同一个 translations 对象。
export const translations = new Proxy(translationsData, {
  get(target, prop) {
    if (prop in target) return target[prop];
    console.warn(`[translations] 语言代码 "${String(prop)}" 还没有对应的翻译内容，已自动退回中文`);
    return target['zh'];
  }
});